import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconInjection: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconInjection"><Path d="M22.0293 5.96973L20.9688 7.03027L19.499 5.56055L17.5596 7.5L21.0293 10.9697L19.9688 12.0303L18.5762 10.6377L9.40332 19.8105L7.3252 17.7334L3.5293 21.5303L2.46875 20.4697L6.26465 16.6729L4.18848 14.5957L13.3613 5.42285L11.9688 4.03027L13.0293 2.96973L16.499 6.43945L18.4385 4.5L16.9688 3.03027L18.0293 1.96973L22.0293 5.96973Z" fill="currentColor"/></CentralIconBase>;
});

export default IconInjection;
